/** Optional view mode toggle — only renders when onViewModeChange is provided. */
import { ViewToggle } from '../ViewToggle';
import { useDataView } from './DataView';

export function DataViewViewToggle({ className }: { className?: string }) {
  const { viewMode, onViewModeChange } = useDataView();
  if (!onViewModeChange) return null;
  return <ViewToggle value={viewMode} onChange={onViewModeChange} className={className} />;
}
